import { lighten, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { PayoffCardRow } from "./payoffCardRow";

const useStyles = makeStyles((theme: Theme) => ({
  totalRow: {
    background: lighten(theme.palette.primary.main, 0.9),
    borderBottom: 'none !important',
  },
}));

export const PayoffCardTotalRow = observer(({ children }) => {
  const classes = useStyles();
  return (
    <PayoffCardRow className={classes.totalRow}>{children}</PayoffCardRow>
  )
});